/**
 * Load Google Identity Services once (#2324). The script is fetched only when
 * a page actually shows the Google button (the providers endpoint said so),
 * never on app boot. A failed load resets, so a later mount can retry.
 */
const GIS_SRC = 'https://accounts.google.com/gsi/client';
let loading: Promise<void> | null = null;

export function loadGoogleIdentity(): Promise<void> {
  if (window.google?.accounts?.id) return Promise.resolve();
  if (loading) return loading;
  loading = new Promise<void>((resolve, reject) => {
    const script = document.createElement('script');
    script.src = GIS_SRC;
    script.async = true;
    script.defer = true;
    script.onload = () => resolve();
    script.onerror = () => {
      loading = null;
      reject(new Error('Google sign-in could not load'));
    };
    document.head.appendChild(script);
  });
  return loading;
}
